import { a as attr, n as nullableNumberConverter, o as observable, V as VividElement } from './vivid-element.js';

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
class BaseProgress extends VividElement {
  constructor() {
    super(...arguments);
    this.percentComplete = 0;
  }
  /**
   * @internal
   */
  valueChanged() {
    if (this.$fastController.isConnected) {
      this.updatePercentComplete();
    }
  }
  /**
   * @internal
   */
  minChanged() {
    if (this.$fastController.isConnected) {
      this.updatePercentComplete();
    }
  }
  /**
   * @private
   */
  maxChanged() {
    if (this.$fastController.isConnected) {
      this.updatePercentComplete();
    }
  }
  /**
   * @internal
   */
  connectedCallback() {
    super.connectedCallback();
    this.updatePercentComplete();
  }
  updatePercentComplete() {
    const min = typeof this.min === "number" ? this.min : 0;
    const max = typeof this.max === "number" ? this.max : 100;
    const value = typeof this.value === "number" ? this.value : 0;
    const range = max - min;
    this.percentComplete = range === 0 ? 0 : Math.fround((value - min) / range * 100);
  }
}
// @ts-expect-error Type is incorrectly non-optional
__decorateClass([
  attr({ converter: nullableNumberConverter })
], BaseProgress.prototype, "value");
// @ts-expect-error Type is incorrectly non-optional
__decorateClass([
  attr({ converter: nullableNumberConverter })
], BaseProgress.prototype, "min");
// @ts-expect-error Type is incorrectly non-optional
__decorateClass([
  attr({ converter: nullableNumberConverter })
], BaseProgress.prototype, "max");
// @ts-expect-error Type is incorrectly non-optional
__decorateClass([
  attr({ mode: "boolean" })
], BaseProgress.prototype, "paused");
__decorateClass([
  observable
], BaseProgress.prototype, "percentComplete");

export { BaseProgress as B };
